import styled from 'styled-components/macro';

const Figure = styled.figure`
  position: relative;
  margin: 0;
  width: 148px;
  border-radius: 2px;
  flex-shrink: 0;
  background-color: transparent;
  transition: background-color 0.25s ease-out;
`;

export default Figure;
